<script setup>

import {azureADAuthentication} from '@/components/ui/AzureADAuthentication'
import {useIsAuthenticated} from '@/composition-api/useIsAuthenticated'
import {homeInfo} from '@/services/importingJsons.js'
import Tooltip from '@/components/Tooltip'
import {store} from '@/store/index.js'

import {ref, onMounted} from 'vue'

const releases = ref(JSON)
const news = ref(JSON)
const links = ref(JSON)
const tools = ref(JSON)
const tutorials = ref(JSON)
const isAzureAdAuthenticated = useIsAuthenticated()

const userHaveBasicRoleAccess = ref(false)

onMounted(() => {
  azureADAuthentication().then(() => {
    userHaveBasicRoleAccess.value = (store.state.isODP_unlimited
        || store.state.isODP_limited
        || store.state.isYQI_Users
        || store.state.isRnDemployee
        || store.state.isRnDconsultant)
    console.log('User have basic role access: ' + userHaveBasicRoleAccess.value)
    console.log('Loading home info data')
    homeInfo().then(response => {
      //disabling releases notes, if there is a need for enable it again
      // releases.value = response?.filter(x => x.id === 'releases')[0]
      news.value = response?.filter(x => x.id === 'news')[0]
      links.value = response?.filter(x => x.id === 'links')[0]
      tools.value = response?.filter(x => x.id === 'tools')[0]
      tutorials.value = response?.filter(x => x.id === 'tutorials')[0]

    })
  }).catch(e => {
    console.log('Error loading home page:' + e)
  })
})

const doSomeStuff = (url) => {
  console.log('User clicked button and went to. ', url)
}

</script>

<template>
  <section>
    <div class="container-fluid">
      <div
          class="row"
          v-if="isAzureAdAuthenticated && userHaveBasicRoleAccess"
      >
        <div
            class="col-6"
        >
          <div
              class="card"
              style="border-color:#dee2e6; height: 500px; "
          >
            <ul class="list-group">
              <h3
                  style="background-color:#f8f9fa; border-color:#f8f9fa; color:black"
                  class="list-group-item active"
              >
                {{ tutorials?.label }}


              </h3>
            </ul>
            <div class="container">
              <div class="row">
                <div
                    v-for="newsItem in tutorials?.items"
                    :key="newsItem.id"
                    class="card-body"
                >
                  <div
                      class="card"
                      style="background-color: #fafafa; padding: 10px; border-radius: 2%; border-color:#033a6a; height: 170px; width: 250px;"
                  >
                    <Tooltip
                        v-if="newsItem.description"
                        :text=newsItem.description
                    >
                      <font-awesome-icon
                          class="pointer mt-1"
                          icon="info-circle"
                      />&nbsp;
                      <font-awesome-icon
                          v-if="newsItem.link_href.includes('youtube')"
                          style="color: red;"
                          :icon="['fab', 'youtube']"
                      />
                    </Tooltip>&nbsp;
                    <!-- <iframe frameborder="0" gesture="media" allow="encrypted-media" width="100" height="100" src="https://www.youtube.com/embed/watch?v=HMOoD1FnWxQ&list=PLVV6eZFA22QwrXd6nSDU18E6XgXSMOs87&index=18"></iframe> -->
                    <a
                        :href="newsItem.link_href"
                        target="_blank"
                        @click="doSomeStuff(newsItem.link_href)"
                    >
                      {{ newsItem.header }}
                    </a>

                    <span style="width: fit-content;"
                          class="badge badge-secondary inverted-badge">{{ newsItem?.subject }}</span>
                    <span style="width: fit-content;" class="badge badge-primary">{{ newsItem?.time_duration }}</span>

                    <br>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <div class="col-3">
          <div
              class="card"
              style="width:100%;border-color:#dee2e6;height: 500px;"
          >
            <ul class="list-group">
              <h3
                  style="background-color:#f8f9fa; border-color:#f8f9fa; color:black;"
                  class="list-group-item active"
              >
                {{ links?.label }}
              </h3>
            </ul>
            <div class="card-body">
              <p
                  v-for="linksItem in links?.items"
                  :key="linksItem.id"
                  class="list-group"
              >

                <a
                    style="width:100%; border-color:#dee2e6; font-weight: normal !important;color:black;"
                    class="btn btn-secondary"
                    :href="linksItem.link_href"
                    target="_blank"
                    @click="doSomeStuff(linksItem.link_href)"
                >{{ linksItem.link_alt }}</a>
              </p>
            </div>
          </div>
        </div>
        <div
            class="col-3"
        >
          <div
              class="card"
              style="height: 500px;border-color:#dee2e6;"
          >
            <ul class="list-group">
              <h3
                  style="background-color:#f8f9fa; border-color:#f8f9fa; color:black"
                  class="list-group-item active"
              >
                {{ tools?.label }}
              </h3>
            </ul>
            <div
                v-for="newsItem in tools?.items"
                :key="newsItem.id"
                class="card-body"
            >
              <div
                  class="card"
                  style="padding: 30px; background-color:#f8f9fa; border-color:#f8f9fa;"
              >
                <h4 class="card-title">
                  {{ newsItem.header }}
                </h4>
                <div
                    class="card-text"
                >
                  <br>
                  {{ newsItem?.description }}
                  <br><br>
                  <a
                      v-if="newsItem.link_href!==undefined"
                      class="btn btn-primary"
                      :href="newsItem.link_href"
                      target="_blank"
                      @click="doSomeStuff(newsItem.link_href)"
                  >
                    {{ newsItem.link_alt }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
      <br>
      <!-- <div v-if="isAzureAdAuthenticated && userHaveBasicRoleAccess" class="row">
        <div
          class="col-6"
        >
          <div
            class="card"
            style="width:100%;border-color:#dee2e6;height:500px"
          >
            <ul
              class="list-group"
              style="border-color:black;"
            >
              <h3
                style="background-color:#f8f9fa; border-color:white; color:black;"
                class="list-group-item active"
              >
                {{ releases?.label }}
              </h3>
            </ul>
            <table
              class="table table-hover"
              style="background-color:#eeeff0; border-color:white; color:black;"
            >
              <thead>
                <tr>
                  <th
                    v-for="header in releases?.headers"
                    :key="header"
                    style="background-color:#033a6a;border-color:#dee2e6;font-size: 15px;"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in releases?.rows"
                  :key="row.id"
                  style="height:auto;"
                >
                  <td
                    v-for="item in row.items"
                    :key="item.id"
                    style="color:black;background-color:white; border-color:#f8f9fa;"
                  >
                    <div
                      v-if="item.type==='timestamp'"
                      style="width:150px"
                    >
                      {{ item?.timestamp }}
                    </div>
                    <div
                      v-if="item.type==='bullet-list'"
                    >
                      <ul
                        v-for="bullet in item.bullets"
                        :key="bullet"
                      >
                        <li>{{ bullet }}</li>
                      </ul>
                    </div>
                    <div
                      v-if="item.type==='link'"
                    >
                      <a
                        :href="item.link_href"
                        target="_blank"
                      >{{ item.link_alt }}</a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> -->
      <div v-if="!isAzureAdAuthenticated || !userHaveBasicRoleAccess">
        <div
            class="col-6"
        >
          <div
              class="card-info"
              style="height:100%;border-color:#dee2e6; background:#eeeff0"
              v-if="!isAzureAdAuthenticated && !userHaveBasicRoleAccess"
          >
            <div class="card-body">
              <h3>Please login to be able to access the portal.</h3><br>
              <h3>If you are not able to login, read more here:</h3>
              <a
                  href="https://scaniaazureservices.sharepoint.com/sites/ECCD-DDM/_layouts/15/Doc.aspx?sourcedoc=%7B81b417fc-58b5-445a-aefb-bd306a29e0a0%7D&action=edit&wd=target%28General+information.one%7C1f9a0475-0c6b-44a2-a317-f2855c14603d%2FAccess+to+Product+Analytics+GUI%7Cf517b1bb-6fc3-4e32-a6d9-4f1fb1b74508%2F%29&wdorigin=703&wdpartid=%7Bb0ef2c32-a144-43d1-bbd3-265c0ff9a34d%7D%7B19%7D&wdsectionfileid=%7B02a38a13-d6f5-468a-afbd-1d93d7983027%7D"
                  target="_blank"
              >
                <h3>
                  <font-awesome-icon
                      icon="book-reader"
                      style="margin-right: 10px;"
                  />
                  How to get access to Product Analytics?
                </h3>
              </a><br>
              <h3>If you have any question:</h3>
              <a
                  href="https://teams.microsoft.com/l/channel/19%3aaead27f3b99c4cf9b0303d5c428fee60%40thread.skype/Product%2520Analytics%2520-%2520Questions?groupId=009a383b-d7c9-42e5-a947-a32fa571402b&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
                  target="_blank"
              >
                <h3>
                  <font-awesome-icon
                      icon="comments"
                      style="margin-right: 10px;"
                  />
                  Contact us
                </h3>
              </a>
            </div>
          </div>
        </div>
        <div
            class="card-info"
            style="height:100%;border-color:#dee2e6; background:#eeeff0"
            v-if="isAzureAdAuthenticated && !userHaveBasicRoleAccess"
        >
          <div class="card-body">
            <h3>
              <c-icon name="scania-information"/>&nbsp;You are authenticated but missing basis role access
            </h3>
            <br>
            <a
                href="https://scaniaazureservices.sharepoint.com/sites/EU_SE_RD_D0054/_layouts/15/Doc.aspx?sourcedoc={18957b04-d287-4bbf-a0fa-33de0aba910a}&action=edit&wd=target%28General%20information.one%7C1f9a0475-0c6b-44a2-a317-f2855c14603d%2FAccess%20to%20Product%20Analytics%20GUI%7Cf517b1bb-6fc3-4e32-a6d9-4f1fb1b74508%2F%29&wdorigin=703"
                target="_blank"
            >

              <h3>
                <font-awesome-icon
                    icon="book-reader"
                />&nbsp;Read how to request role access to Product Analytics
              </h3>
            </a>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>


<style scoped>
.inverted-badge {
  color: #033a6a;
  border: 1px solid #033a6a;
  background-color: #fafafa;
}

.container {
  overflow-y: scroll;
  height: 500px;
}

.table {
  overflow-y: scroll;
  height: 500px;
  display: block;
}

/* Styles for the card container */
.card-info {
  border-radius: 10px;
  padding: 20px;
  width: 750px; /* Adjust the width as needed */
  margin: 0px; /* Add margin for spacing */
  box-shadow: 3px 0 0 0 #e9ecef;; /* Add shadow for depth */
  background-color: #f9f9f9; /* Change background color */
}

/* Styles for the card title */
.card-info-title {
  font-size: 20px;
  margin-bottom: 10px;
  color: #033a6a; /* Change title color */
}

/* Styles for the link */
.professional-link {
  color: #033a6a; /* Link color */
  text-decoration: none; /* Remove underline */
  font-weight: bold; /* Make the text bold */
  transition: color 0.3s ease; /* Smooth color transition on hover */
}

.professional-link:hover {
  color: #0056b3; /* Darker color on hover */
}

</style>
